<template>
    <span @mousedown="dragStart"> <slot></slot> </span>
</template>

<script>
export default {
    props: ["data"],
    methods: {
        dragStart(e) {
            const bbox = e.target.getBoundingClientRect();
            this.position = {
                x: bbox.x,
                y: bbox.y,
                width: bbox.width,
                height: bbox.height
            };

            this.dragPreview = e.target.cloneNode(true);
            document.body.append(this.dragPreview);
            this.originStyle = this.dragPreview.getAttribute("style");
            this.dragPreview.setAttribute("style", this.draggedStyle());

            document.addEventListener("mousemove", this.drag);
            document.addEventListener("mouseup", this.dragEnd);
        },
        drag(e) {
            this.position = {
                ...this.position,
                x: e.pageX,
                y: e.pageY
            };
            this.dragPreview.setAttribute("style", this.draggedStyle());
        },
        draggedStyle() {
            return (
                this.originStyle +
                "position:absolute;z-index:10000;" +
                `top:${this.position.y - this.position.height / 2}px;` +
                `left:${this.position.x - this.position.width / 2}px;` +
                `pointer-events: none;`
            );
        },
        dragEnd(e) {
            this.dragPreview.remove();
            this.dragPreview = undefined;
            this.position = undefined;
            this.originStyle = undefined;
            document.removeEventListener("mousemove", this.drag);
            document.removeEventListener("mouseup", this.dragEnd);
            this.$emit("dragEnd", e, this.data);
        }
    },
    beforeDestroy() {
        document.removeEventListener("mouseup", this.dragEnd);
    }
};
</script>



// WEBPACK FOOTER //
// draggable.vue?023f93c7